import { useState, useEffect, Fragment } from "react";
import { useFormikContext } from "formik";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import Field from "../../../utils/FormikFields/Field";
import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";
import { InputLabel, autoCompleteDisplayLabel } from "../../../utils/Common";

import { formatGenericDate } from "../../../utils/util";

import { useInvoiceData } from "../../../contexts/InvoiceData";

import { useQuery } from '@tanstack/react-query';

import { getStylists } from "../../Stylists/apiService";

const SelectRep = () => {

  const { values, setFieldValue } = useFormikContext() || {};

  let repairs = values?.repairs || [];

  const [serverOptions, setServerOptions] = useState(null);

  let { invoice_data } = useInvoiceData() || {};

  let rep = invoice_data?.stylist_rep

  const { data: stylists} = useQuery({
    queryKey: ['stylists'],
    queryFn: () => getStylists(),
  })

  useEffect(() => {
    if (stylists) {
      setServerOptions(stylists);
    }
  }, [stylists])

  useEffect(() => {
    if (rep) {
      setFieldValue('stylist_rep', rep);
    }
  }, [rep])
  

  return (
    <Fragment>
      <Grid size={{xs: 12}}>
        <InputLabel>Select Rep</InputLabel>
          <AutoCompleteSolo 
            name = "stylist_rep"
            url = "inventory"
            fieldName = "stylist_id"
            displayField= "full_name"
            serverOptions={serverOptions}
            // forceServer={true}
            // disabled={repairs?.length > 0}
          />
      </Grid>
    </Fragment>
  )

};

export default SelectRep;